export const KEY = {
  SELECTED_CLIENT_ID: 'fp_selectedClientId',
  SELECTED_SITE_ID: 'fp_selectedSiteId',
  SELECTED_SECTOR_ID: 'fp_selectedSectorId',

  SELECTED_DAY: 'fp_selectedDay',
  SELECTED_VIEW: 'fp_selectedView',
};